import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PCB_CHANNEL } from '../../../constants/treeConstants';
import {
  getAMISignalList
} from '../../../services/Andes_v2/channel/AMIModelHelper';
import {
  updateADSConfig
} from '../store/channel/action';
import AMIModelRender from '../AMIModel';
import { filterTestPoint } from '../../../services/Andes_v2/channel';

class AMIModel extends Component {

  render() {
    const { adsConfig = {}, signals, components, selectedSignals, serdesType, comp_merges } = this.props;
    const _components = filterTestPoint(components, comp_merges);
    const { amiSignals: adsSignals, amiAllSignals: adsAllSignals } = getAMISignalList({ adsConfig, signals, components: _components, selectedSignals, serdesType });
    return <AMIModelRender
      {...this.props}
      adsSignals={adsSignals}
      interfaceType={PCB_CHANNEL}
      adsAllSignals={adsAllSignals}
      components={_components}
    />
  }
}

const mapState = (state) => {
  const {
    channel: { channelInfo: { content = {}, adsConfig, type }, channelId }
  } = state.AndesV2Reducer;
  const {
    components = [],
    signals = [],
    selectedSignals = [],
    comp_merges = [],
    comp_copies = []
  } = content;

  return {
    components,
    signals,
    selectedSignals,
    adsConfig,
    channelId,
    serdesType: type,
    comp_merges,
    comp_copies
  }
}

const mapDispatch = (dispatch) => ({
  _updateADSConfig(adsConfig, options) {
    dispatch(updateADSConfig(adsConfig, options))
  }
})

export default connect(mapState, mapDispatch)(AMIModel);